module.exports = "https://web-assets-production.autolist.com/_next/static/images/warranty-516c1c419ffffa2d8a2f57770ad1dc23.svg";